const en = {
  'branch-discrepancy': require('./branch-discrepancy.json'),
  'task-management': require('./task-management.json'),
  'cash-balance': require('./cash-balance.json'),
  'sales-summary': require('./sales-summary.json'),
  'transfer-in-out': require('./transfer-in-out.json'),
  'branch-overview': require('./branch-overview.json'),
  'pouch-preparation': require('./pouch-preparation.json'),
  'record-known-variance': require('./record-known-variance'),
  'manage-cash-drawer': require('./manage-cash-drawer.json'),
  'paid-in-out': require('./paid-in-out.json'),
  'version-info': require('./version-info.json'),
  'transaction-log': require('./transaction-log.json'),
  table: require('./table.json'),
  'date-time-range': require('./date-time-range.json'),
  common: require('./common.json'),
  'manual-stockBook': require('./manualStockBook.json'),
  'cash-movement-history': require('./cash-movement-history.json'),
  'cash-count-history': require('./cash-count-history.json'),
  'monthly-weekly-balance': require('./monthly-weekly-balance.json'),
  'pouch-history': require('./pouch-history.json'),
  'printing-modals': require('./printing-modals.json'),
  'denomination-ladder': require('./denomination-ladder.json'),
  'weekly-monthly-balance-history': require('./weekly-monthly-balance-history.json'),
  'checkbox-dropdown': require('./checkbox-dropdown.json'),
  'storage-config': require('./storage-config.json'),
  'display-table': require('./display-table.json'),
  'transaction-viewer': require('./transaction-viewer.json'),
  'number-range-dropdown': require('./number-range-dropdown.json'),
  'number-range': require('./number-range.json'),
};

export default en;
